// extracted by mini-css-extract-plugin
export default {"root":"Toggle_root__ryrld","option":"Toggle_option__LYsBm","selected":"Toggle_selected__5dV+g"};